// Imports
// --------------------------------
import React, { useState } from 'react';
import {
  Header, Main, Item, Modal
} from './styles';
import { ImageLoader } from '../../../components/common';
import defaultAvatar from '../../../images/defaultAvatar.png';
import { getHeader, apiUrl } from '../../../helpers/utils';

const validateImportUrl = (value) => {
  return (/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value)) && /wishlist/g.test(value)
}

// Render
// --------------------------------
const RegistryForm = ({ profile, registry, setRegistry }) => {
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [search, setSearch] = useState('');
  const [importError, setImportError] = useState(false);
  const [timeoutState, setTimeoutState] = useState(null);
  const [fetching, setFetching] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  
  
  const httpRequestSearch = (query) => {
    fetch(`${apiUrl}/search?q=${query}/`)
      .then((response) => {
        const json = response.json();
        if (response.ok) {
          return json;
        }
        return Promise.reject('Something went wrong.');
      })
      .then((json) => {
        setSearchResults(json.data);
        setFetching(false);
      })
      .catch((e) => {
        console.log('e', e);
        setFetching(false);
      });
  };

  const httpRequestImport = (url) => {
    fetchfetch(`${apiUrl}/import-list?url=${url}/`)
      .then((response) => {
        const json = response.json();
        if (response.ok) {
          return json;
        }
        return Promise.reject('Something went wrong.');
      })
      .then((json) => {
        setSearchResults(json.data);
        setFetching(false);
      })
      .catch((e) => {
        console.log('e', e);
        setSearch('');
        setImportError(true);
        setFetching(false);
      });
  };

  const scrapeWishlist = (e) => {
    if (search && search.length > 0) {
      if (validateImportUrl(search)) {
        clearTimeout(timeoutState);
        setTimeoutState(
          setTimeout(() => {
            httpRequestImport(search);
            setFetching(true);
          }, 500)
        );
      } else {
        setImportError(true);
        setFetching(false);
        setSearch('');
      }
    }
  };

  const onChangeSearch = (event) => {
    setSearch(event.target.value);
  };

  const onKeyUpSearch = (event) => {
    if (search && search.length > 0) {
      clearTimeout(timeoutState);
      setTimeoutState(
        setTimeout(() => {
          httpRequestSearch(search);
          setFetching(true);
        }, 500)
      );
    }
  };

  const handleKeyDownSearch = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onKeyUpSearch(event);
    }
  };

  const handleKeyDownImport = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      scrapeWishlist(event);
    }
  };

  const onClickToggleSearchModal = () => {
    setShowSearchModal(!showSearchModal);
    setSearchResults([]);
    setSearch('');
  };

  const onClickToggleImportModal = () => {
    setShowImportModal(!showImportModal);
    setSearchResults([]);
    setSearch('');
  };

  const addItem = (item) => () => {
    setRegistry([...registry, item]);
    onClickToggleSearchModal();
  };

  const addItemImport = (item) => async () => {
    let newSearchResults = [...searchResults];
    newSearchResults = newSearchResults.filter((resultItem) => resultItem.name !== item.name);
    setSearchResults(newSearchResults);
    await setRegistry([...registry, item]);
  };

  const importAll = (wishlistRegistry) => async () => {
    await setRegistry([...registry, ...wishlistRegistry]);
    onClickToggleImportModal();
  };

  const deleteItem = (k) => () => {
    const newRegistry = [...registry.slice(0, k), ...registry.slice(k + 1)];
    setRegistry(newRegistry);
  };

  const {
    banner, firstName, lastName, avatar
  } = profile;

  return (
    <div style={{ minWidth: '100%' }}>
      <Header background={getHeader(banner)}>
        <div>
          <a>
            <ImageLoader
              alt="Avatar"
              className="user-profile-img-2"
              src={avatar || defaultAvatar}
            />
          </a>
        </div>
        <div>
          <button className="search" type="button" onClick={onClickToggleSearchModal}>Add Item</button>
          <button className="import" type="button" onClick={onClickToggleImportModal}>Import Amazon Wishlist</button>
        </div>
      </Header>
      <Main>
        {registry && registry.length > 0 ? (
          <section>
            {registry.map((i, k) => (
              <Item key={`Item-${k}`}>
                {/* <dl> */}
                {/*  <dt>...</dt> */}
                {/*  <dd onClick={deleteItem(k)}>Delete</dd> */}
                {/* </dl> */}
                <span>
                  $
                  {i.price}
                </span>
                <button className="modal-close-button" type="button" onClick={deleteItem(k)}>&times;</button>
                <img alt={i.name} src={i.image} />
                <h3>{i.name}</h3>
                <a
                  href={`https://www.amazon.com${i.url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View On Amazon
                </a>
              </Item>
            ))}
          </section>
        ) : (
          <section>
            <p>
              There are no items in your registry.
              <br />
              <span onClick={onClickToggleSearchModal}>Start By Adding An Item</span>
            </p>
          </section>
        )}
      </Main>

      <Modal show={showSearchModal}>
        <div>
          <button type="button" className="modal-close-button" onClick={onClickToggleSearchModal}>&times;</button>
          <h1>Add Item</h1>
          <input
            onSubmit={(e) => { e.preventDefault(); }}
            disabled={fetching}
            type="search"
            value={search}
            onChange={onChangeSearch}
            onKeyDown={handleKeyDownSearch}
            // onKeyUp={onKeyUpSearch}
            placeholder="Search for products"
          />
          <button className="importButton" type="button" onClick={onKeyUpSearch}>search</button>
          <section>
            {fetching && (
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38"
                  height="38"
                  viewBox="0 0 38 38"
                  stroke="#666666"
                >
                  <g fill="none">
                    <g transform="translate(1 1)" strokeWidth="2">
                      <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                      <path
                        d="M36 18c0-9.94-8.06-18-18-18"
                        transform="rotate(277.527 18 18)"
                      >
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 18 18"
                          to="360 18 18"
                          dur="1s"
                          repeatCount="indefinite"
                        />
                      </path>
                    </g>
                  </g>
                </svg>
              </div>
            )}
            {!fetching
            && searchResults
            && searchResults.length > 0
            && searchResults.map((i, k) => (
              <article key={`registry-${k}`}>
                <div>
                  <img alt={i.name} src={i.image} />
                </div>
                <h3>{i.name}</h3>
                <span>
                  $
                  {i.price}
                </span>
                <button type="button" onClick={addItem(i)}>+</button>
              </article>
            ))}
          </section>
        </div>
      </Modal>
      <Modal show={showImportModal}>
        <div>
          <button type="button" className="modal-close-button" onClick={onClickToggleImportModal}>&times;</button>
          {
           !fetching && searchResults.length === 0
            && (
              <>
                <h1>Import Amazon Wishlist</h1>
                <p>
                  1.Go to
                  <a href="https://www.amazon.com/wishlist" target="_blank" rel="noreferrer"> your lists.</a>
                  <br />
                  2. Choose the relevant list and select Send list to others.
                  <br />
                  3. Choose "View only".
                  <br />
                  4. Copy the link and paste below:
                </p>
                <input
                  disabled={fetching}
                  onKeyDown={handleKeyDownImport}
                  onClick={() => {
                    if (importError) setImportError(false);
                  }}
                  type="search"
                  value={search}
                  className={importError ? 'import-input-error' : 'import-input'}
                  onChange={onChangeSearch}
                  placeholder={importError ? 'Invalid Wishlist Link. Try again!' : 'Paste your Amazon Wishlist URL'}
                />
                <button className="importButton" type="button" onClick={scrapeWishlist}>import</button>
              </>
            )
          }
          <section>
            {fetching && (
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38"
                  height="38"
                  viewBox="0 0 38 38"
                  stroke="#666666"
                >
                  <g fill="none">
                    <g transform="translate(1 1)" strokeWidth="2">
                      <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                      <path
                        d="M36 18c0-9.94-8.06-18-18-18"
                        transform="rotate(277.527 18 18)"
                      >
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 18 18"
                          to="360 18 18"
                          dur="1s"
                          repeatCount="indefinite"
                        />
                      </path>
                    </g>
                  </g>
                </svg>
              </div>
            )}
            { !fetching
            && searchResults
            && searchResults.length > 0
              && (
                <article key="registry-0">
                  <button
                    type="button"
                    className="input-button"
                    onClick={importAll(searchResults)}
                  >
                    IMPORT ALL
                  </button>
                  <h2>
                    or import one by one:
                  </h2>
                </article>
              )}
            {!fetching
            && searchResults
            && searchResults.length > 0
            && searchResults.map((i, k) => (
              <article key={`registry-${k}`}>
                <div>
                  <img alt={i.name} src={i.image} />
                </div>
                <h3>{i.name}</h3>
                <span>
                  $
                  {i.price}
                </span>
                <button type="button" onClick={addItemImport(i)}>+</button>
              </article>
            ))}
          </section>
        </div>
      </Modal>
    </div>
  );
};

export default RegistryForm;
